<div *ngIf="userOrigin && years && years.length">
    <form [formGroup]="yearsForm" class="year-form">
        <section class="budget-field">
            <p>{{'parameters.originSelector.form.lastYear.fullLabel' | translate}}</p>
            <mat-radio-group class="budget-options" formControlName="year">
                <div *ngFor="let year of years">
                    <mat-radio-button [value]="year.code"> 
                        {{ userOrigin.provider.category.code === providerType.bbc ? year.text.shortLabel : year.year }} 
                    </mat-radio-button>
                    <app-tooltip [text]="year.text.summary"></app-tooltip>
                </div>
            </mat-radio-group>
        </section>
    </form>

    <section class="actions" *ngIf="paramLink && isParamLinkVisible">
        <a mat-button [routerLink]="paramLink.route">
            <mat-icon aria-label="Settings">{{ paramLink.icon }}</mat-icon>
            {{ paramLink.title | translate }}
        </a>
    </section>
</div>
